import $ from 'jquery';

import Swiper from 'swiper';
import {Navigation, Pagination, EffectCreative, Autoplay } from "swiper/swiper.esm";
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay]);

const initiativesSlider  = new Swiper('.initiatives-slider',{
    slidesPerView: 1,
    autoHeight: false,
    loop: true,
    spaceBetween: 35,
    effect: 'creative',
    speed: 800,
    centeredSlides: true,
    watchSlidesProgress: true,
    creativeEffect: {
        limitProgress: 2,
        perspective: true,
        prev: {
            translate: ['-120%', 0 , 0],
        },
        next: {
            translate: ["120%", 0 , 0],
        },
    },
    navigation:{
        nextEl: ".initiatives-swiper-button-next",
        prevEl: ".initiatives-swiper-button-prev",
    },
    on: {
        slideChangeTransitionEnd: function () {
            let $activeSlide = $('.swiper-slide-active');
            let $titleElement = $activeSlide.find('.init_card__title');
            let titleText = $titleElement.text();
            $('.title-callout').text(titleText);
        }
    },
    breakpoints: {
        900: {
            slidesPerView: 2.3,
            creativeEffect: {
                limitProgress: 2,
                perspective: true,
                prev: {
                    translate: ['-120%', '70%' , 0],
                },
                next: {
                    translate: ["120%", '70%' , 0],
                },
            },
        },
        1300: {
            slidesPerView: 3.3,
            creativeEffect: {
                limitProgress: 2,
                perspective: true,
                prev: {
                    translate: ['-120%', '70%' , 0],
                },
                next: {
                    translate: ["120%", '70%' , 0],
                },
            },
        },
    }
})